import { createCrudSagas } from "./CrudSagas";
import { ContextValuesActions } from "../reducers/ContextValuesRedux";

const crudSagas = createCrudSagas("contextValues", ContextValuesActions);

export const findContextValues = crudSagas.findContextValues;
export const getContextValue = crudSagas.getContextValue;
export const watchContextValues = crudSagas.watchContextValues;
export const unwatchContextValues = crudSagas.unwatchContextValues;